import "core-js/modules/es.array.for-each";
import "core-js/modules/es.function.name";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, commonData, pageSize } from "@/mixins/index";
import addGifeCode from './component/addGifeCode.vue';
import uploadImagetow from '@/components/uploadImagetow';
export default {
  name: "giftCode",
  mixins: [loadMoreList, commonData, pageSize],
  components: {
    addGifeCode: addGifeCode,
    uploadImagetow: uploadImagetow
  },
  data: function data() {
    return {
      paramsData: {
        page: 1,
        code: '',
        level_id: '',
        start_expire_time: '',
        end_expire_time: '',
        start_create_time: '',
        end_create_time: '',
        server_id: ''
      },
      tableData: [],
      total: 0,
      codeList: [],
      value1: [],
      value2: [],
      value3: [],
      serverAllList: []
    };
  },
  created: function created() {
    this.getList();
    this.getCodeList();
    this.getServerList();
  },
  methods: {
    getList: function getList() {
      var _arguments = arguments,
          _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var page;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                page = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : 1;
                _this.paramsData.page = page;

                if (_this.value2 && _this.value2.length) {
                  _this.paramsData.start_expire_time = _this.value2[0];
                  _this.paramsData.end_expire_time = _this.value2[1];
                } else {
                  _this.paramsData.start_expire_time = '';
                  _this.paramsData.end_expire_time = '';
                }

                if (_this.value1 && _this.value1.length) {
                  _this.paramsData.start_create_time = _this.value1[0];
                  _this.paramsData.end_create_time = _this.value1[1];
                } else {
                  _this.paramsData.start_create_time = '';
                  _this.paramsData.end_create_time = '';
                }

                if (_this.value3 && _this.value3.length) {
                  _this.paramsData.active_start_time = _this.value3[0];
                  _this.paramsData.active_end_time = _this.value3[1];
                } else {
                  _this.paramsData.active_start_time = '';
                  _this.paramsData.active_end_time = '';
                }

                _this.$api.giftCodeList(_this.paramsData).then(function (res) {
                  if (res.code == 200) {
                    var data = res.data.data;
                    data.forEach(function (item) {
                      item.level_code_id = item.level.id;
                      item.name = item.level.name, item.student_name = item.student ? item.student.name : '/';
                      item.isExpired = _this.checkExpired(item.expire_time);
                    });
                    _this.tableData = data;
                    _this.total = res.data.total;
                  }
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    checkExpired: function checkExpired(expire_time) {
      var currentTime = new Date();
      var expireTime = new Date(expire_time);
      return currentTime > expireTime;
    },
    getServerList: function getServerList() {
      var _this2 = this;

      this.$api.serverList({
        page_size: -1
      }).then(function (res) {
        if (res.code == 200) {
          _this2.serverAllList = res.data;
        }
      });
    },
    recycleCode: function recycleCode(id) {
      var _this3 = this;

      this.$confirm("此操作将回收该礼包码, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.$api.recycleGiftCode({
                  id: id
                }).then(function (res) {
                  if (res.code == 200) {
                    _this3.$message.success("回收成功!");

                    _this3.getList(_this3.paramsData.page);
                  } else {
                    _this3.$message.error(res.msg);
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    },
    getCodeList: function getCodeList() {
      var _this4 = this;

      this.$api.giftCodeLevelList().then(function (res) {
        if (res.code == 200) {
          _this4.codeList = res.data;
        }
      });
    },
    handleDelete: function handleDelete(id) {
      var _this5 = this;

      this.$confirm("此操作将删除该礼包码, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this5.$api.delGiftCode({
                  id: id
                }).then(function (res) {
                  if (res.code == 200) {
                    _this5.$message.success("删除成功!");

                    _this5.getList(_this5.paramsData.page);
                  } else {
                    _this5.$message.error(res.msg);
                  }
                });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })));
    },
    exportDataFn: function exportDataFn() {
      var _this6 = this;

      this.columns = [{
        label: '礼包码',
        prop: 'code'
      }, {
        label: '礼包码等级',
        prop: 'name'
      }, {
        label: '激活码过期时间',
        prop: 'expire_time'
      }, {
        label: '生效到期时间',
        prop: 'end_period_time'
      }, {
        label: '是否使用',
        prop: 'is_use'
      }, {
        label: '被使用的学生',
        prop: 'student_name'
      }, {
        label: '激活时间',
        prop: 'active_time'
      }, {
        label: '礼包码状态',
        prop: 'isExpired'
      }, {
        label: '卡号',
        prop: 'card_number'
      }, {
        label: '服务器',
        prop: 'server_name'
      }];
      this.$api.giftCodeList(_objectSpread(_objectSpread({}, this.paramsData), {}, {
        page_size: -1
      })).then(function (res) {
        if (res.code == 200) {
          var data = res.data;
          data.forEach(function (item) {
            item.level_code_id = item.level.id;
            item.name = item.level.name, item.student_name = item.student ? item.student.name : '/';
            item.isExpired = _this6.checkExpired(item.expire_time) == true ? '已过期' : '未过期';
            item.is_use = item.is_use == 1 ? '已使用' : '未使用';
          });

          _this6.$export.excel({
            columns: _this6.columns,
            data: data,
            title: '礼包码'
          });
        }
      });
    }
  }
};